import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ReportRoot = superstyled({
  name: 'MarketReport',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.border.main}`
  })
});

export const ReportHeader = superstyled({
  name: 'MarketReport',
  slot: 'Header',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.border.main}`
  })
});

export const Section = superstyled({
  name: 'MarketReport',
  slot: 'Section',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  })
});

export const SectionTitle = superstyled({
  name: 'MarketReport',
  slot: 'SectionTitle',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  })
});

export const SectionContent = superstyled({
  name: 'MarketReport',
  slot: 'SectionContent',
  tag: Box,
  styles: ({ theme }) => ({
    paddingLeft: theme.spacing(1)
  })
});

export const CompetitorCard = superstyled({
  name: 'MarketReport',
  slot: 'CompetitorCard',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.border.light}`
  })
});

export const List = superstyled({
  name: 'MarketReport',
  slot: 'List',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingLeft: theme.spacing(2)
  })
});

export const ListItem = superstyled({
  name: 'MarketReport',
  slot: 'ListItem',
  tag: Text,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    '&::before': {
      content: '"•"',
      marginRight: theme.spacing(1),
      color: theme.palette.primary.main
    }
  })
});

export const RecommendationCard = superstyled({
  name: 'MarketReport',
  slot: 'RecommendationCard',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.border.light}`,
    '&:last-child': {
      marginBottom: 0
    }
  })
});

export const PriorityBadge = superstyled({
  name: 'MarketReport',
  slot: 'PriorityBadge',
  tag: 'span',
  styles: ({ theme, ownerState }) => {
    const priorityColors = {
      High: {
        bg: theme.palette.error.light,
        color: theme.palette.error.dark
      },
      Medium: {
        bg: theme.palette.warning.light,
        color: theme.palette.warning.dark
      },
      Low: {
        bg: theme.palette.success.light,
        color: theme.palette.success.dark
      }
    };
    const colors = priorityColors[ownerState?.priority] || priorityColors.Medium;
    return {
      display: 'inline-block',
      padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
      borderRadius: theme.shape.borderRadius,
      fontSize: '0.75rem',
      fontWeight: 500,
      backgroundColor: colors.bg,
      color: colors.color,
      textTransform: 'uppercase'
    };
  }
});

export const ActionBar = superstyled({
  name: 'MarketReport',
  slot: 'ActionBar',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.border.main}`
  })
});
